import React, { useEffect, useState } from 'react';
import { 
  IonContent, 
  IonPage,  
  IonCard, 

  IonCardHeader, 
  IonCardSubtitle, 
  IonCardTitle, 
  IonCardContent,  
  IonGrid, 
  IonRow, 
  IonCol } from '@ionic/react';


// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import firebase from "firebase/app";

// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/firestore";
import "firebase/database";
import "firebase/storage";


// TODO: Replace the following with your app's Firebase project configuration
// For Firebase JavaScript SDK v7.20.0 and later, `measurementId` is an optional field


// Initialize Firebase



//kantar
//99q97s7j60jke25y0ju99j0tpvspr3yz1xsqqzd79a1wttt88q7ug6as615cmz6a

//
//ppebpx6zsjnk15sgyc19cpcnzhq9gucpjnbetau0k2ehtbv38k53h0arvpmwz7ef
import Axios from 'axios';
import {AppNotification, Admin} from '../assets/DataStructures';
import { Plugins, PushNotification, PushNotificationActionPerformed, Capacitor, PermissionType, PushNotificationToken  } from '@capacitor/core';
import {CheckCircleOutline, ArrowForward} from '@material-ui/icons';
import { useAuth0 } from "@auth0/auth0-react";
import { Button, 
  AppBar, 
  Toolbar, 
  Typography, 
  Grid, 
  TextField, 
  Card, 
  CardContent, 
  Dialog, 
  DialogActions,
   DialogContent, 
   DialogContentText, 
   DialogTitle } from '@material-ui/core';
import useStyles from '../assets/cssClasses';
import { URLS } from '../assets/URLS';
const { PushNotifications, Permissions } = Plugins;


interface dbProps {
  db: firebase.database.Database | null,
  on_id_add: Function,
  on_new_token: Function,
  ids: Array<string>,
  admin: Admin | null,
  ios: Boolean,
  token: string,
}

const Surveys: React.FC<dbProps> = (props) => {

  const [database, setDB] = useState<firebase.database.Database | null>(null);
  const [surveys, setSurveys] = useState<any>({});

  const [notifications, setNotifications] = useState<Array<AppNotification>>([]);
  const [new_id, setNewId] = useState<string>('');
  const [ids, setIDs] = useState<Array<string>>([]);
  const { loginWithRedirect, logout, user, isAuthenticated } = useAuth0();
  const [push_state, setPushState] = useState<string>('');

  const classes = useStyles();

  useEffect(()=>{
    if(props.token.length <=0 ){
      console.log('calling token from Surveys');
      PushNotifications.addListener('registration',
      (token: PushNotificationToken) => {
        //alert('registration');
        props.on_new_token(token.value);
      }
    );
    }
  },[props.token])

  useEffect(() => {
    PushNotifications.addListener('pushNotificationReceived',
      (notification: PushNotification) => {
        //alert('got notificatoin');
        var note = new AppNotification(notification.data.modal_title,notification.data.modal_message,notification.data.modal_image)
        var n_notes = [...notifications];
        n_notes.push(note);
        console.log(JSON.stringify(notification))
        setNotifications(n_notes);
        
      }
    );

    // Method called when tapping on a notification
    PushNotifications.addListener('pushNotificationActionPerformed',
      (notification: PushNotificationActionPerformed) => {
        //alert('got notificatoin');
        var note = new AppNotification(notification.notification.data.modal_title,notification.notification.data.modal_message,notification.notification.data.modal_image)
        var n_notes = [...notifications];
        n_notes.push(note);
        console.log(JSON.stringify(notification))
        setNotifications(n_notes);
      }
    );
 
    Permissions.query({name: PermissionType.Notifications}).then((res)=>{
      console.log(JSON.stringify(res));
      if(res.state !== 'granted'){
        PushNotifications.requestPermission().then(()=>{
          //alert('request after denied');
          Permissions.query({name: PermissionType.Notifications}).then((res)=>{
            setPushState(res.state);
          });
        });
      }else{
        setPushState("granted");
      }
      
    })
  }, [])

  useEffect(() => {
    console.log(JSON.stringify({ids: props.ids, token: props.token}));
    if (props.token.length>0) {
      /////grant privileges to surveys
      
        firebase.auth().signInAnonymously().then(()=>{
          console.log('granting privileges to surveys');
           
           if(props.ids.length > 0){
             //alert(JSON.stringify(ids));
             Axios.get(URLS.token, { params: { 'duids': props.ids.join('_'), 'uid':  firebase.auth().currentUser?.uid, 'admin': props.admin?.active} }).then(()=>{
               firebase.auth().currentUser?.getIdTokenResult(true).then(res=>{
                 firebase.auth().currentUser?.reload().then(()=>{

                  console.log('Setting token for SURVEYS')
                  props.ids.forEach((a, ind) => {
                    console.log("DUID: "+a);
                    var usr_token_ref = database?.ref('/users/' + a + '/token');
                    usr_token_ref?.set(props.token).then(()=>{},(rejection)=>{console.log(JSON.stringify(rejection))});
                      
                  })
                  AsyncIds(props.ids);
                 });
             })})
           }
           
         })
 
      /////

      
    } else {
      PushNotifications.requestPermission().then(result => {
        if (result.granted) {
          //alert('granted')
          PushNotifications.register();
        } else {
          //alert('not granted')
          PushNotifications.register();
        }
      });
    }


  }, [props.ids, props.token, props.admin])
  
  

  useEffect(() => {

    setDB(props.db);

  }, [props.db]);

  useEffect(() => {
    setIDs(props.ids);
  }, [props.ids]);

  
  useEffect(() => {
    /*
    if(props.token.length > 0){
      firebase.auth().signInAnonymously().then(()=>{
        console.log('granting privileges to surveys');
         
         if(ids.length > 0){
           //alert(JSON.stringify(ids));
           Axios.get(URLS.token, { params: { 'duids': ids.join('_'), 'uid':  firebase.auth().currentUser?.uid, 'admin': props.admin?.active} }).then(()=>{
             firebase.auth().currentUser?.getIdTokenResult(true).then(res=>{
               firebase.auth().currentUser?.reload().then(()=>{AsyncIds(ids)});
               
           })}).then()
         }
         
       })
    }else{
      console.log("POSTPONE PRIVILEGES TO SURVEYS")
    }
    
     */
    
  }, [ids, props.token, database, props.admin]);

  const AsyncIds =  (ids:Array<string>) => {
    var all_promises = []
    console.log(ids);
    if(ids){

      for(var i=0; i<ids.length; i++){
        all_promises.push(database?.ref('users/'+ids[i]+'/surveys').once('value'));
        //assign listeners 
          
            database?.ref('users/'+ids[i]+'/surveys').on('value', (snap)=>{
              //alert('SURVEY CHANGED');
              //alert(JSON.stringify({ind: i, survey: snap.val()}));
              var nsurveys = Object.assign({}, surveys?surveys:{});
              if(snap.val()){
                var survey_key = Object.keys(snap.val())[0];
                nsurveys[i] = snap.val()[survey_key];
                setSurveys(nsurveys);
              }
              
            })
       
          
 
        
        /*database?.ref('users/'+ids[i]+'/surveys').on('child_removed', function(snapshot) {
          if(snapshot.val()){
     
            //alert(JSON.stringify(snapshot));
            var k = Object.keys(snapshot.val())[0];
            nsurveys[k] = null;
            //alert(k);
            
          }
        });*/

      }

    }
    
    Promise.all(all_promises).then((values)=>{
      //alert("GOT VALUES")
      console.log(values);
      var nsurveys = Object.assign({}, surveys);
      if(values.length){
        values.forEach((snap,ind)=>{
          console.log(snap?.val());
          console.log(snap);
          if(snap?.val()){
            var k:string = Object.keys(snap.val())[0];
            console.log(k);
            nsurveys[k] = snap.val()[k];
          }
        })
        console.log(nsurveys);
        setSurveys(nsurveys);
      }
      
    })
  }

  const onNoteRemove = (ind:number) => {
    var notes = [...notifications];
    notes.splice(ind,1);
    setNotifications(notes);
  }


  return (
    <IonPage>
       
      <IonContent>

      <Grid container spacing={2}>

          <Grid item xs={12}>
            <AppBar className={props.ios?classes.page_title_ios:classes.page_title} position="sticky">
              <Toolbar>
                <Typography className={classes.title} variant="h6">
                  <span className={classes.left_align_block}>Bright DSM | Available Surveys
                  {isAuthenticated &&
                      <span> | {user.email}</span>
                    }
                  </span>
                  <span className={classes.right_align_block}>
                    {!isAuthenticated && !Capacitor.isNative &&
                      <Button onClick={() => loginWithRedirect()} className={classes.actionButton}>Log In as Admin</Button>
                    }
                    {isAuthenticated && !Capacitor.isNative &&
                      <Button onClick={() => logout({ returnTo: window.location.origin })} className={classes.actionButton}>Log Out</Button>
                    }
                  </span>
                </Typography>
              </Toolbar>
            </AppBar>
          </Grid>


          <Grid item xs={12}>
            {notifications.map((a, ind) => {
            return (
              <Dialog
              fullWidth={false}
              maxWidth="md"
              open={true}
              onClose={()=>onNoteRemove(ind)}
              aria-labelledby="max-width-dialog-title"
            >
              <DialogTitle>{a.title}</DialogTitle>
                <DialogContent>
                  <div className={classes.center_align} id={'notofocation_'+ind} key={'notofocation_'+ind}>
                    <img src={a.image_url} width='150' alt=""/>
                    <DialogContentText>
                      <Typography variant="h5">{a.message}</Typography>
                    </DialogContentText>
                  </div>
                </DialogContent>
              <DialogActions>
                <Button onClick={()=>onNoteRemove(ind)} color="primary">
                  Close
                </Button>
              </DialogActions>
            </Dialog>
 

            )
          })}
        </Grid>
        {push_state !== 'granted' &&
          <Grid item xs={12} className={classes.nopadding}>
            <Card>
            <CardContent className={classes.outlined_card}>
              <Typography variant="body1" className={classes.card_title_grey}>
              Push notifications are disabled. Please enable them through your phone settings to ensure the diary manager will work properly.</Typography>
            </CardContent>

          </Card>
            
            </Grid>
        }
        
        <Grid item xs={12} className={classes.nopadding}>
          <Card>
            <CardContent className={classes.outlined_card}>
              <Typography variant="h6" className={classes.card_title}>Register New Survey</Typography>
              <div className={classes.padded_15} id={'new_survey_div'} key={'new_survey_div'}>
                <TextField id="new_id_textfield" label="Survey ID" value={new_id} onChange={e => setNewId(e.target.value.toUpperCase())} inputProps={{autoCapitalize: 'on',}}/>

                <Button onClick={() => props.on_id_add(new_id)} className={classes.actionButton} startIcon={<CheckCircleOutline/>}>Register</Button>
              </div>

            </CardContent>

          </Card>
        </Grid>
        {surveys && 
        <Grid item xs={12}>
          {Object.keys(surveys).map((keyName, i) => {
              return(
                <React.Fragment key={'survey'+i}>

                {surveys[keyName] && 
                  <IonCard>
                    <IonCardHeader> 
                      <IonCardTitle className={classes.survey_header}>{surveys[keyName].respondent_name}</IonCardTitle>
                      <IonCardSubtitle>Details</IonCardSubtitle>
                    </IonCardHeader>

                    <IonCardContent>
                      <IonGrid>
                        <IonRow>
                          <IonCol sizeLg="2" sizeMd="2">Name</IonCol>
                          <IonCol sizeLg="10" sizeMd="10">{surveys[keyName].respondent_name}</IonCol>
                        </IonRow>
                        <IonRow>
                          <IonCol sizeLg="2" sizeMd="2">Description</IonCol>
                          <IonCol sizeLg="10" sizeMd="10">{surveys[keyName].description}</IonCol>
                        </IonRow>
                        <IonRow>
                        {surveys[keyName].last_notification && 
                          <IonCol sizeLg="10" sizeMd="10">{surveys[keyName].last_notification}</IonCol>
                        }

                        </IonRow>
                      </IonGrid>

                      {surveys[keyName].active && 
                        <Button className={classes.actionButton} startIcon={<ArrowForward/>}><a href={surveys[keyName].link} target="_blank" className={classes.a_link}>Take the survey</a></Button>
                      }
                      
                    </IonCardContent>
                  </IonCard>
                }
                </React.Fragment>
              )
            })}
        </Grid>
        }
      </Grid>
      </IonContent>
    </IonPage>
  );
};

export default Surveys;
